document.addEventListener('DOMContentLoaded', function() {
  function updateProgressMessages(cartTotal) {
    let freeShippingThreshold = 1300;
    let interestFreeThreshold = 1500;

    let freeShippingMessage = document.getElementById('free-shipping');

    // Caso 1: No se ha alcanzado ningún objetivo
    if (cartTotal < freeShippingThreshold) {
      let remainingShipping = freeShippingThreshold - cartTotal;
      let remainingInterestFree = interestFreeThreshold - cartTotal;
      freeShippingMessage.innerHTML = `Si compras $${remainingShipping.toLocaleString('en-US')} más tu envío será gratis o agrega $${remainingInterestFree.toLocaleString('en-US')} para acceder a 3 meses sin intereses y envío gratis.`;
      freeShippingMessage.style.color = "black"; // Azul oscuro
    }

    // Caso 2: Se ha alcanzado el envío gratis pero no los 3 meses sin intereses
    else if (cartTotal >= freeShippingThreshold && cartTotal < interestFreeThreshold) {
      let remainingInterestFree = interestFreeThreshold - cartTotal;
      freeShippingMessage.innerHTML = `¡Felicidades tienes tu envío gratis!.<br>Si acumulas $${remainingInterestFree.toLocaleString('en-US')} más también obtendrás 3 meses sin intereses.`;
      freeShippingMessage.style.color = "black"; // Rojo oscuro
    }

    // Caso 3: Se han alcanzado ambos logros (envío gratis y meses sin intereses)
    else if (cartTotal >= interestFreeThreshold) {
      freeShippingMessage.innerHTML = "¡Felicidades! Has accedido a 3 meses sin intereses con tarjetas de crédito participantes y envío gratis.";
      freeShippingMessage.style.color = "black"; // Verde oscuro
    }
  }

  // Función para obtener el carrito actual y actualizar los mensajes
  function fetchAndUpdateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartTotal = cart.total_price / 100; // Convertir de centavos a la moneda normal
        updateProgressMessages(cartTotal);
      });
  }

  // Inicializar al cargar la página
  fetchAndUpdateCart();
});
